import {RecursosController} from "../recursos";

export class YoutubeController extends RecursosController {

    /* INSTANCE */
    public static instance: YoutubeController;

    /* STATIC */
    public static override async build(): Promise<void> {
        YoutubeController.instance = new this();
        RecursosController.instances.push(YoutubeController.instance);
    }

    private constructor() {
        super();
        this.getResources(document.body).then(async()=>{
            await this.init();
            this.scrollEvent = this.lazyResources.bind(this);
            document.addEventListener("scroll", this.scrollEvent);
        });
    }

    protected async getResources(html: HTMLElement): Promise<void> {
        const resources = Array.from(html.querySelectorAll("[class*='youtube-head'], [class*='youtube-body'], [class*='youtube-live']"));
        for (let resource of resources) this.resources.push(resource as HTMLElement);
    }

    protected async load(item: HTMLElement) : Promise<void> {
        item.innerHTML = item.getAttribute("data-lazy") as string;
    }

}
